import { Component, Prop, h, State, Element, Listen, Watch, Host, Event, EventEmitter } from '@stencil/core';

import state from './pn-profile-modal-store';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';
@Component({
  tag: 'pn-profile-modal',
  styleUrl: 'pn-profile-modal.scss',
})
export class PnProfileModal {
  @Element() hostElement: Element;

  @Prop() heading: string = null;
  @Prop() continueCtaText: string = null;
  @Prop() choosenCompanyText: string = null;
  @Prop() toText: string = null;
  @Prop() chooseCustomerNumberText: string = null;

  @State() isLoading: boolean = true;

  componentWillLoad() {
    this.populateState();
    this.bindEvents();
  }
  populateState() {
    state.i18n.chooseCustomerNumberText = this.chooseCustomerNumberText;
    state.i18n.choosenCompanyText = this.choosenCompanyText;
    state.i18n.toText = this.toText;
    const selectedType = this.hostElement.querySelector('pn-profile-modal-type[selected="true"]');
    if (selectedType) {
      state.selectedType = selectedType.getAttribute('name');
    }
  }
  bindEvents() {
    const segmentControl = this.hostElement.querySelector('pn-segmented-control');
    if (segmentControl) {
      segmentControl.addEventListener('change', this.onSegmentControlChange.bind(this));
    }
  }
  onSegmentControlChange(e) {
    const contentId = e.target.value;
    const content = this.hostElement.querySelector(`[typeid="${contentId}"]`);
    if (content) {
      const types = [...this.hostElement.querySelectorAll('pn-profile-modal-type')];
      types.forEach(type => {
        type.setAttribute('selected', (type.getAttribute('typeid') === contentId) + '');
      });
    }
  }

  onCTAClick() {
    if (!state.selectedUrl) {
      console.log('no Url as been selected, will not continue');
    }
  }
  @Listen('urlSelected')
  onUrlSelected(e) {
    if (!e || !e.detail) {
      return;
    }
    state.selectedUrl = e.detail;
    const ctaBtn = this.hostElement.querySelector('.profilemodal-cta pn-button');
    if (ctaBtn) {
      ctaBtn.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
    }
  }

  render() {
    return (
      <Host>
        <div class="profilemodal-container">
          <div class="profilemodal-logo">
            <svg viewBox="0 0 133 26" fill="none" xmlns="http://www.w3.org/2000/svg" width="17.1rem" height="3.2rem">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#00A0D6"
                d="M132.749 0.333618V20.9198H126.976V19.3809C126.976 19.3809 125.475 21.4316 122.191 21.4316C117.381 21.4316 114.662 17.7015 114.662 13.0327C114.662 8.47612 117.776 4.7187 122.617 4.7187C125.589 4.7187 126.976 6.19924 126.976 6.19924V1.47206L132.749 0.333618ZM54.2322 1.67091H60.0055V5.20216H65.3564L62.7235 10.0999H60.0055V20.9198H54.2322V1.67091ZM28.2484 21.4023C32.8051 21.4023 37.6446 18.8974 37.6446 12.9187C37.6446 7.16616 32.9746 4.69042 28.4461 4.69042C23.8042 4.69042 19.049 7.25192 19.049 13.175C19.049 18.9549 23.7199 21.4023 28.2484 21.4023ZM28.3327 9.78608C30.2294 9.78608 31.5032 11.1243 31.5032 13.0902C31.5032 14.9392 30.2575 16.3076 28.3327 16.3076C26.437 16.3076 25.1351 14.9392 25.1351 13.0902C25.1351 11.1243 26.4089 9.78608 28.3327 9.78608ZM47.0708 10.8963C46.8158 10.8574 46.5804 10.8239 46.3639 10.7931C44.9938 10.5979 44.3827 10.5108 44.3827 9.87279C44.3827 9.24608 45.146 8.9888 46.6465 8.9888C49.1941 8.9888 51.4298 9.84357 51.4298 9.84357L52.4488 5.43022C52.4488 5.43022 49.9865 4.71869 46.7027 4.71869C41.1841 4.71869 38.2965 6.85422 38.2965 10.2705C38.2965 12.9187 39.8532 14.485 44.4108 15.0825C46.3355 15.3388 47.0427 15.4519 47.0427 16.1644C47.0427 16.8486 46.2784 17.0757 44.9484 17.0757C42.0608 17.0757 39.3437 15.8515 39.3437 15.8515L38.1832 20.4081C38.1832 20.4081 40.9003 21.375 44.4389 21.375C50.3826 21.375 53.1279 19.2668 53.1279 15.8223C53.1279 13.0902 51.6555 11.6087 47.0708 10.8963ZM76.1968 4.69042C72.8287 4.69042 71.6111 6.74018 71.6111 6.74018V5.20216H65.8369V20.9198H71.6111V12.8612C71.6111 10.8689 72.3483 9.95666 74.1297 9.95666C75.913 9.95666 76.1687 11.4381 76.1687 13.3173V20.9198H81.9982V11.2666C81.9982 6.93903 79.9339 4.69042 76.1968 4.69042ZM123.948 9.8153C125.843 9.8153 127.144 11.1818 127.144 13.0327C127.144 14.9958 125.87 16.335 123.948 16.335C122.051 16.335 120.778 14.9958 120.778 13.0327C120.778 11.1818 122.024 9.8153 123.948 9.8153ZM112.456 10.213C110.53 10.213 109.088 10.9537 109.088 13.3456V20.9198H103.313V5.20216H109.088V7.02479C109.088 7.02479 109.965 4.97409 113.191 4.97409C114.181 4.97409 114.55 5.14467 114.55 5.14467L114.408 10.4976C114.408 10.4976 113.643 10.213 112.456 10.213ZM11.9728 13.0902C11.9728 11.1243 10.699 9.78608 8.80235 9.78608C6.87853 9.78608 5.6038 11.1243 5.6038 13.0902C5.6038 14.9392 6.9057 16.3076 8.80235 16.3076C10.728 16.3076 11.9728 14.9392 11.9728 13.0902ZM10.1333 21.4023C14.9728 21.4023 18.0871 17.6468 18.0871 13.0902C18.0871 8.41958 15.3699 4.69042 10.5576 4.69042C7.27472 4.69042 5.77426 6.74018 5.77426 6.74018V5.20216H0V25.4453H5.77426V19.9227C5.77426 19.9227 7.16139 21.4023 10.1333 21.4023ZM95.7984 13.0902C95.7984 11.1243 94.5246 9.78608 92.6279 9.78608C90.7032 9.78608 89.4284 11.1243 89.4284 13.0902C89.4284 14.9392 90.7322 16.3076 92.6279 16.3076C94.5536 16.3076 95.7984 14.9392 95.7984 13.0902ZM92.5427 21.4023C97.0994 21.4023 101.94 18.8974 101.94 12.9187C101.94 7.16616 97.2698 4.69042 92.7413 4.69042C88.0984 4.69042 83.3442 7.25192 83.3442 13.175C83.3442 18.9549 88.0142 21.4023 92.5427 21.4023Z"
              ></path>
            </svg>
          </div>

          {this.heading === '' ? null : <div class="profilemodal-heading">{this.heading}</div>}
          <div class="profilemodal-content">
            <slot />
          </div>
          {this.continueCtaText ? (
            <div class="profilemodal-cta" aria-hidden={!state.selectedUrl + ''}>
              <pn-button onclick={this.onCTAClick} href={state.selectedUrl} icon={arrow_right}>
                {this.continueCtaText}
              </pn-button>
            </div>
          ) : null}
        </div>
      </Host>
    );
  }
}
